var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmerald(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2191_1168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9186 120H28.4203L14 105.58V14.4203L28.4203 0H91.9186L106.339 14.4203V105.58L91.9186 120ZM29.2746 117.966H91.0644L104.305 104.725V15.2339L91.0644 2.0339H29.2746L16.0339 15.2746V104.766L29.2746 117.966Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5666 10.4784L79.9089 15.3623L80.7229 15.9719L84.3805 11.088L83.5666 10.4784Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9191 5.39581L32.1094 6.01108L35.9733 11.096L36.783 10.4808L32.9191 5.39581Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2569 0.714849L28.4561 1.34164L32.1165 6.01843L32.9174 5.39164L29.2569 0.714849Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0859 0.692388L87.427 5.37045L88.228 5.99697L91.8869 1.3189L91.0859 0.692388Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4293 5.39565L83.5654 10.4806L84.3751 11.0959L88.239 6.01092L87.4293 5.39565Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7698 10.4649L35.9688 11.0915L39.6276 15.7695L40.4286 15.143L36.7698 10.4649Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7116 104.237L79.9109 104.864L83.5722 109.541L84.3729 108.914L80.7116 104.237Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6277 104.232L35.9631 108.906L36.7634 109.533L40.428 104.86L39.6277 104.232Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5484 119.492H27.7891L32.3043 113.776L33.1179 114.427L29.9043 118.475H90.4331L87.2196 114.427L88.0331 113.776L92.5484 119.492Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3729 108.915L83.5593 109.525L87.2204 114.407L88.0339 113.796L84.3729 108.915Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9742 108.906L32.3098 113.785L33.1229 114.396L36.7874 109.517L35.9742 108.906Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3152 24.8339L88.7864 23.9797L94.2779 20.7254L94.8067 21.6L89.3152 24.8339Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.289 101.669L99.7808 102.55L105.066 105.599L105.574 104.718L100.289 101.669Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2779 99.2746L88.7864 96.0407L89.3152 95.1458L94.8067 98.4L94.2779 99.2746Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07 14.3949L99.7839 17.443L100.292 18.324L105.578 15.2759L105.07 14.3949Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8074 21.5999L94.2786 20.7253L99.7701 17.471L100.299 18.3456L94.8074 21.5999Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7701 102.529L94.2786 99.2746L94.8074 98.4001L100.299 101.654L99.7701 102.529Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2555 101.462L14.7629 104.721L15.2818 105.595L20.7744 102.337L20.2555 101.462Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0575 20.9196L25.5493 21.8005L30.8346 24.8495L31.3428 23.9686L26.0575 20.9196Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5434 98.4151L20.2576 101.463L20.7656 102.344L26.0514 99.2961L25.5434 98.4151Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8376 95.3475L25.5518 98.3955L26.0598 99.2765L31.3456 96.2284L30.8376 95.3475Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7679 17.6683L20.2349 18.5344L25.5179 21.7858L26.0509 20.9197L20.7679 17.6683Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2738 14.4085L14.7551 15.2832L20.2483 18.5408L20.767 17.6661L15.2738 14.4085Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0169 18.1017H20V17.4915L32.1424 5.32883L32.8746 6.06103L21.0169 17.8983V18.1017Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0169 18.1017H20V101.898H21.0169V18.1017Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7119 114.61H32.3051L20 102.305V101.898H20.7119L20.8746 101.736L32.8746 113.736L32.7119 113.898V114.61Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6262 113.593H32.7109V114.61H87.6262V113.593Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1957 5.34307L87.4766 6.06216L99.6867 18.2723L100.406 17.5532L88.1957 5.34307Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8298 5.18652H32.5078V6.20347H87.8298V5.18652Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6993 101.728L87.2883 113.734L87.9954 114.465L100.406 102.458L99.6993 101.728Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.542 17.8983H99.5254V102.102H100.542V17.8983Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0509 21.1525H94.0339V98.8474H95.0509V21.1525Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1776 21.5186L83.8047 11.1457L83.9674 10.983V10.2711H84.3742L94.9098 20.7864L94.1776 21.5186Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1433 21.5185L26.0009 21.3558H25.2891V20.9287L36.0077 10.4134L36.7399 11.1456L26.1433 21.5185Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.966 10.2712H36.3728V11.2881H83.966V10.2712Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.966 108.712H36.3728V109.729H83.966V108.712Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.306 21.3558H25.2891V98.8473H26.306V21.3558Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3322 109.586L83.6204 108.854L94.1763 98.4814L94.8882 99.2136L84.3322 109.586Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3721 109.729H35.9653L25.4297 99.2136L26.1619 98.4814L36.5348 108.854L36.3721 109.017V109.729Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7186 96.1627L30.3728 95.7966V24.4068L30.7186 24.0407L31.2881 24.6102H31.3898V95.5932H31.2881L30.7186 96.1627Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.034 105.051H39.6272L30.7188 96.1627L31.451 95.4305L40.1967 104.176L40.034 104.339V105.051Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.939 16.0271L79.8983 15.9661H40.0339V14.9492H80.3051L80.6712 15.2949L80.1017 15.8644V15.9661L79.939 16.0271Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6616 15.1085L30.7161 24.054L31.4352 24.7731L40.3807 15.8276L39.6616 15.1085Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6816 95.2576L79.9346 104.199L80.6615 104.91L89.4086 95.9688L88.6816 95.2576Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3051 104.034H40.0339V105.051H80.3051V104.034Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6513 15.298L79.9324 16.0172L88.6781 24.7599L89.397 24.0407L80.6513 15.298Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5587 24.4069H88.5417V95.5933H89.5587V24.4069Z",
    fill: "#81D8D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2191_1168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.339,
    height: 120,
    fill: "white",
    transform: "translate(14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/Emerald.c696d769ac07563a1455689e01bd6ced.svg";
export { ForwardRef as ReactComponent };